// extracted by mini-css-extract-plugin
module.exports = {"edit__switch":"index--edit__switch--1bazH","switch__message":"index--switch__message--mriu-","switch__error":"index--switch__error--2QEEc"};